import { message } from 'antd'
import downloadFile from 'utils/downloadFile'

const downloadUsingAPI = async (
	file: string | ArrayBufferView | ArrayBuffer | Blob,
	fileName: string
) => {
	try {
		const url = window.URL.createObjectURL(new Blob([file]))
		downloadFile(url, fileName)
	} catch (error: any) {
		message.error(error?.message || `Error downloading file: ${fileName}`)
	}
}

export default downloadUsingAPI
